import { render, staticRenderFns } from "./pageNotFound.vue?vue&type=template&id=7c74ba38&scoped=true&"
import script from "./pageNotFound.vue?vue&type=script&lang=js&"
export * from "./pageNotFound.vue?vue&type=script&lang=js&"
import style0 from "./pageNotFound.vue?vue&type=style&index=0&id=7c74ba38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c74ba38",
  null
  
)

export default component.exports